import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ProfileTab from "../../../core/common/profiletab";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";

const Miscellaneous = () => {
  const routes = all_routes;
  const [firstRef, setFirstRef] = useState({
    ref_id: null,
    ref_person_name: "",
    ref_person_relation: "",
    ref_person_contact_number: "",
    ref_person_years_known: "",
  });
  const [secondRef, setSecondRef] = useState({
    ref_id: null,
    ref_person_name: "",
    ref_person_relation: "",
    ref_person_contact_number: "",
    ref_person_years_known: "",
  });

  const [data, setData] = useState({
    miscellaneous_id: "",
    uan_number: "",
    is_pf_exist: "No",
    is_pf_withdrawn: "No",
    pf_number: "",
    passport_number: "",
    esic_number: "",
    aadhar_number: "",
    pan_number: "",
    about_yourself: "",
    hobbies: "",
    payment_mode: "",
    country: "",
    bank_name: "",
    account_number: "",
    ifsc_code: "",
    payment_currency: "INR",
  });

  const [specifyRef, setSpecifyRef] = useState({
    name1: "",
    name2: "",
    name3: "",
    ref1: "",
    ref2: "",
    ref3: "",
  });

  const getspecref = (e: any) => {
    const { name, value } = e.target;
    setSpecifyRef({ ...specifyRef, [name]: value });
  };
  const {
    data: onboardingstatus,
    loading: onboardingstatusLoading,
    error: onboardingstatusError,
  } = useApi("/api/onboarding/final-status", {
    method: "GET",
    autoCall: true,
  });

  const status = onboardingstatus?.data?.onb_status;
  const [isEditable, setIsEditable] = useState(false);

  const {
    data: miscellaneousViewData,
    loading: miscellaneousLoading,
    error: miscellaneousError,
  } = useApi("/api/onboarding/view-miscellaneous", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (miscellaneousViewData?.data) {
      const misc = miscellaneousViewData.data;
      setData({
        miscellaneous_id: misc.miscellaneous_id || "",
        uan_number: misc.uan_number || "",
        is_pf_exist: misc.is_pf_exist || "No",
        is_pf_withdrawn: misc.is_pf_withdrawn || "No",
        pf_number: misc.pf_number || "",
        passport_number: misc.passport_number || "",
        esic_number: misc.esic_number || "",
        aadhar_number: misc.aadhar_number || "",
        pan_number: misc.pan_number || "",
        about_yourself: misc.about_yourself || "",
        hobbies: misc.hobbies || "",
        payment_mode: misc.payment_mode || "",
        country: misc.country || "",
        bank_name: misc.bank_name || "",
        account_number: misc.account_number || "",
        ifsc_code: misc.ifsc_code || "",
        payment_currency: misc.payment_currency || "",
      });
      if (misc.refPersonData?.length > 0) {
        if (misc.refPersonData[0]) {
          setFirstRef({
            ref_id: misc.refPersonData[0].refrence_id || null,
            ref_person_name: misc.refPersonData[0].name || "",
            ref_person_relation: misc.refPersonData[0].relation || "",
            ref_person_contact_number:
              misc.refPersonData[0].contact_number?.toString() || "",
            ref_person_years_known:
              misc.refPersonData[0].years_known?.toString() || "",
          });
        }
        if (misc.refPersonData[1]) {
          setSecondRef({
            ref_id: misc.refPersonData[1].refrence_id || null,
            ref_person_name: misc.refPersonData[1].name || "",
            ref_person_relation: misc.refPersonData[1].relation || "",
            ref_person_contact_number:
              misc.refPersonData[1].contact_number?.toString() || "",
            ref_person_years_known:
              misc.refPersonData[1].years_known?.toString() || "",
          });
        }
      }

      if (misc.declarationData?.length > 0) {
        setDeclarations(
          misc.declarationData.map((d: any) => ({
            mis_dec_id: d.ID,
            declaration_id: d.declaration_id,
            status: d.status,
            declaration_text: d.declaration_text || "",
          }))
        );
      }
    }
  }, [miscellaneousViewData]);

  const [declarations, setDeclarations] = useState<any>([]);

  const {
    data: DeclarationtData,
    loading: DeclarationtLoading,
    error: DeclarationtError,
  } = useApi("/api/onboarding/get-declaration", {
    method: "GET",
    autoCall: true,
  });

  const getInputData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleDeclarationChange = (id: any, status: any) => {
    setDeclarations((prev: any) => {
      const existing = prev.find((d: any) => d.declaration_id === id);
      const updated = prev.filter((d: any) => d.declaration_id !== id);

      return [
        ...updated,
        {
          declaration_id: id,
          status,
          declaration_text: existing?.declaration_text || "",
          mis_dec_id: existing?.mis_dec_id || null,
        },
      ];
    });
  };

  const handleDeclarationTextChange = (id: any, text: any) => {
    setDeclarations((prev: any) =>
      prev.map((item: any) =>
        item.declaration_id === id
          ? {
            ...item,
            declaration_text: text,
            mis_dec_id: item.mis_dec_id || null,
          }
          : item
      )
    );
  };

  const {
    data: miscellaneousData,
    loading,
    error,
    callApi: postMiscellaneousData,
  } = useApi("/api/onboarding/add-miscellaneous", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: any) => {
    e.preventDefault();
    const ref_person_data = [];

    if (
      firstRef.ref_person_name &&
      firstRef.ref_person_contact_number &&
      firstRef.ref_person_relation 
    ) {
      ref_person_data.push({
        ...firstRef,
        ref_person_years_known: parseInt(
          firstRef.ref_person_years_known
        ),
      });
    }

    if (
      secondRef.ref_person_name &&
      secondRef.ref_person_contact_number &&
      secondRef.ref_person_relation 
    ) {
      ref_person_data.push({
        ...secondRef,
        ref_person_years_known: parseInt(
          secondRef.ref_person_years_known 
        ),
      });
    }

    const payload = {
      ...data,
      ref_person_data,
      declaration_data: declarations,
    };
    try {
      const response = await postMiscellaneousData(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("closeModalBtn")?.click();
        });
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const {
    data: miscellaneousEditData,
    loading: miscellaneousEditLoading,
    error: miscellaneousEditError,
    callApi: editMiscellaneousData,
  } = useApi("/api/onboarding/edit-miscellaneous", {
    method: "POST",
    autoCall: false,
  });

  const handleEdit = async (e: any) => {
    e.preventDefault();
    try {
      const ref_person_data = [];

      if (
        firstRef.ref_person_name &&
        firstRef.ref_person_contact_number &&
        firstRef.ref_person_relation &&
        firstRef.ref_person_years_known
      ) {
        ref_person_data.push({
          ...firstRef,
          ref_person_years_known: parseInt(
            firstRef.ref_person_years_known || "0"
          ),
        });
      }

      if (
        secondRef.ref_person_name &&
        secondRef.ref_person_contact_number &&
        secondRef.ref_person_relation &&
        secondRef.ref_person_years_known
      ) {
        ref_person_data.push({
          ...secondRef,
          ref_person_years_known: parseInt(
            secondRef.ref_person_years_known || "0"
          ),
        });
      }

      const payload = {
        ...data,
        miscellaneous_id: data.miscellaneous_id,
        ref_person_data,
        declaration_data: declarations,
      };
      console.log(payload);
      const response = await editMiscellaneousData(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("editcloseModalBtn")?.click();
        });
        setIsEditable(false);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const {
    data: miscellaneousspecRefViewData,
    loading: miscellaneousspecRefViewLoading,
    error: miscellaneousspecRefViewError,
  } = useApi("/api/onboarding/view-ref-miscellaneous", {
    method: "GET",
    autoCall: true,
  });

  const refDatadata = miscellaneousspecRefViewData?.data;
  useEffect(() => {
    if (refDatadata?.length > 0) {
      const result: { [key: string]: string } = {};

      refDatadata.forEach((item: any, index: number) => {
        result[`name${index + 1}`] = item.ref_name;
        result[`ref${index + 1}`] = item.ref_relation;
      });

      setSpecifyRef((prev) => ({
        ...prev,
        ...result,
      }));
    }
  }, [refDatadata]);

  const {
    data: miscellaneousspecRefData,
    loading: miscellaneousspecRefLoading,
    error: miscellaneousspecRefError,
    callApi: miscellaneousspecRefDataPost,
  } = useApi("/api/onboarding/add-ref-miscellaneous", {
    method: "POST",
    autoCall: false,
  });
  const specpostData = async (e: any) => {
    e.preventDefault();
    const { name1, name2, name3, ref1, ref2, ref3 } = specifyRef;
    const person_data = [];
    if (name1 && ref1) {
      person_data.push({
        ref_name: name1,
        ref_relation: ref1,
      });
    }
    if (name2 && ref2) {
      person_data.push({
        ref_name: name2,
        ref_relation: ref2,
      });
    }
    if (name3 && ref3) {
      person_data.push({
        ref_name: name3,
        ref_relation: ref3,
      });
    }
    const payload = {
      person_data,
    };
    try {
      const response = await miscellaneousspecRefDataPost(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("closeModalBtn")?.click();
        });
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Miscellaneous</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Administration</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Miscellaneous
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
            <div className="row">
              <div className="col-xl-3 theiaStickySidebar">
                <div
                  className="stickybar"
                  style={{ position: "sticky", top: "50px" }}
                >
                  <ProfileTab />
                </div>
              </div>
              <div className="col-xl-9">
                <div className="card">
                  <div className="card-body">
                    <div className="border-bottom mb-3 pb-3">
                      <h4>Miscellaneous</h4>
                    </div>
                    <form>
                      {/* Present Address Section */}
                      <div className="border-bottom mb-3">
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className="mb-3">Miscellaneous details</h6>
                          </div>
                        </div>
                        <div className="row">
                          {/* <!-- UAN Number --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  UAN Number<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="tel"
                                  className="form-control"
                                  placeholder="Enter your UAN Number"
                                  name="uan_number"
                                  maxLength={12}
                                  pattern="\d*"
                                  inputMode="numeric"
                                  value={data.uan_number}
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                  onKeyPress={(e) => {
                                    if (!/^\d$/.test(e.key)) {
                                      e.preventDefault(); // blocks non-digit keys
                                    }
                                  }}
                                  required
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- PF in the Last Company? (Radio Buttons) --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  PF in the Last Company ?
                                </label>
                              </div>
                              <div className="col-md-8">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="is_pf_exist"
                                    id="pfInLastCompanyYes"
                                    value="Yes"
                                    checked={data.is_pf_exist === "Yes"}
                                    onChange={getInputData}
                                    disabled={
                                      data.miscellaneous_id || firstRef.ref_id
                                        ? !isEditable
                                        : false
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="pfInLastCompanyYes"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="is_pf_exist"
                                    id="pfInLastCompanyNo"
                                    value="No"
                                    checked={data.is_pf_exist === "No"}
                                    onChange={getInputData}
                                    disabled={
                                      data.miscellaneous_id || firstRef.ref_id
                                        ? !isEditable
                                        : false
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="pfInLastCompanyNo"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* <!-- Is the Last Company PF Withdrawn? (Radio Buttons) --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Is the Last Company PF Withdrawn ?
                                </label>
                              </div>
                              <div className="col-md-8">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="is_pf_withdrawn"
                                    id="pfWithdrawnYes"
                                    value="Yes"
                                    checked={data.is_pf_withdrawn === "Yes"}
                                    onChange={getInputData}
                                    disabled={
                                      data.miscellaneous_id || firstRef.ref_id
                                        ? !isEditable
                                        : false
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="pfWithdrawnYes"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="is_pf_withdrawn"
                                    id="pfWithdrawnNo"
                                    value="No"
                                    checked={data.is_pf_withdrawn === "No"}
                                    onChange={getInputData}
                                    disabled={
                                      data.miscellaneous_id || firstRef.ref_id
                                        ? !isEditable
                                        : false
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="pfWithdrawnNo"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* <!-- Last company PF number (Select) --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Last company PF number
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Last Company PF Number"
                                  name="pf_number"
                                  value={data.pf_number}
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Passport Number (Text Input) --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Passport Number
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Passport Number"
                                  name="passport_number"
                                  value={data.passport_number}
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Last company ESIC number (Text Input) --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Last company ESIC number
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Last Company ESIC Number"
                                  name="esic_number"
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.esic_number}
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Aadhar Number (Text Input) --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Aadhar Number
                                  <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="tel"
                                  className="form-control"
                                  placeholder="Enter Aadhar Number"
                                  name="aadhar_number"
                                  maxLength={12}
                                  pattern="\d*"
                                  inputMode="numeric"
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.aadhar_number}
                                  onKeyPress={(e) => {
                                    if (!/^\d$/.test(e.key)) {
                                      e.preventDefault(); // blocks non-digit keys
                                    }
                                  }}
                                  required
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Pan Number (Text Input) --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Pan Number<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Pan Number"
                                  name="pan_number"
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.pan_number}
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Write about yourself (Text Area) --> */}
                          <div className="col-md-12">
                            <div className="row align-items-start mb-3">
                              <div className="col-xxl-2 col-md-3">
                                <label className="form-label mb-md-0">
                                  Write about yourself
                                </label>
                              </div>
                              <div className="col-xxl-10 col-md-9">
                                <textarea
                                  className="form-control"
                                  rows={2}
                                  placeholder="Write a brief description about yourself"
                                  name="about_yourself"
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.about_yourself}
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Hobbies (Text Area) --> */}
                          <div className="col-md-12">
                            <div className="row align-items-start mb-3">
                              <div className="col-xxl-2 col-md-3">
                                <label className="form-label mb-md-0">
                                  Hobbies<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-xxl-10 col-md-9">
                                <textarea
                                  className="form-control"
                                  rows={2}
                                  placeholder="Enter your hobbies"
                                  name="hobbies"
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.hobbies}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Emergency Contact Section */}
                      <div className="border-bottom mb-3">
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className="">References</h6>
                            <p className="mb-3">
                              List two persons not related to you who may have
                              knowledge of your work performance within the past
                              five years.
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          {/* <!-- Name --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Name<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter reference name"
                                  name="ref_person_name"
                                  value={firstRef.ref_person_name}
                                  onChange={(e) =>
                                    setFirstRef({
                                      ...firstRef,
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Relationship/Title --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Relationship/Title<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter relationship or title"
                                  name="ref_person_relation"
                                  value={firstRef.ref_person_relation}
                                  onChange={(e) =>
                                    setFirstRef({
                                      ...firstRef,
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Phone Number --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Phone Number<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="tel"
                                  className="form-control"
                                  placeholder="Enter phone number"
                                  name="ref_person_contact_number"
                                  maxLength={10}
                                  pattern="\d*"
                                  inputMode="numeric"
                                  value={firstRef.ref_person_contact_number}
                                  onChange={(e) =>
                                    setFirstRef({
                                      ...firstRef,
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                  onKeyPress={(e) => {
                                    if (!/^\d$/.test(e.key)) {
                                      e.preventDefault(); // blocks non-digit keys
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Years Known --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Years Known
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter number of years known"
                                  name="ref_person_years_known"
                                  value={firstRef.ref_person_years_known}
                                  onChange={(e) =>
                                    setFirstRef({
                                      ...firstRef,
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="border-bottom mb-3">
                        <div className="row">
                          {/* <!-- Name --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Name
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter reference name"
                                  name="ref_person_name"
                                  value={secondRef.ref_person_name}
                                  onChange={(e) =>
                                    setSecondRef({
                                      ...secondRef,
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Relationship/Title --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Relationship/Title
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter relationship or title"
                                  name="ref_person_relation"
                                  value={secondRef.ref_person_relation}
                                  onChange={(e) =>
                                    setSecondRef({
                                      ...secondRef,
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Phone Number --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Phone Number
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="tel"
                                  className="form-control"
                                  placeholder="Enter phone number"
                                  name="ref_person_contact_number"
                                  maxLength={10}
                                  pattern="\d*"
                                  inputMode="numeric"
                                  value={secondRef.ref_person_contact_number}
                                  onChange={(e) =>
                                    setSecondRef({
                                      ...secondRef,
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                  onKeyPress={(e) => {
                                    if (!/^\d$/.test(e.key)) {
                                      e.preventDefault(); // blocks non-digit keys
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Years Known --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Years Known
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter number of years known"
                                  name="ref_person_years_known"
                                  value={secondRef.ref_person_years_known}
                                  onChange={(e) =>
                                    setSecondRef({
                                      ...secondRef,
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Spouse Details Section */}
                      <div className="border-bottom mb-3">
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className="mb-3">Bank Details</h6>
                          </div>
                        </div>
                        <div className="row">
                          {/* <!-- Payment Mode --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Payment mode
                                </label>
                              </div>
                              <div className="col-md-8">
                                <select
                                  className="form-control"
                                  name="payment_mode"
                                  value={data.payment_mode}
                                  onChange={getInputData}
                                  disabled={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                >
                                  <option value="">Select Payment Mode</option>
                                  <option value="Bank">Bank</option>
                                  <option value="Cash">Cash</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          {/* <!-- Country --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Country<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter country"
                                  name="country"
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.country}
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Bank Name --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Bank name<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter custom bank name"
                                  name="bank_name"
                                  value={data.bank_name}
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                  required
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Bank Account Number --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Bank A/c No
                                  <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter bank account number"
                                  name="account_number"
                                  pattern="\d*"
                                  inputMode="numeric"
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.account_number}
                                  onKeyPress={(e) => {
                                    if (!/^\d$/.test(e.key)) {
                                      e.preventDefault(); // blocks non-digit keys
                                    }
                                  }}
                                  required
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- IFSC Code --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  IFSC code<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter IFSC code"
                                  name="ifsc_code"
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.ifsc_code}
                                />
                              </div>
                            </div>
                          </div>

                          {/* <!-- Payment Currency --> */}
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Payment Currency
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter payment currency (e.g., USD)"
                                  name="payment_currency"
                                  onChange={getInputData}
                                  readOnly={
                                    data.miscellaneous_id || firstRef.ref_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.payment_currency}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="border-bottom mb-3">
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className="mb-3">Declaration by Candidate</h6>
                          </div>
                        </div>
                        <div className="row">
                          {/* <!-- Payment Mode --> */}
                          <div className="col-md-12">
                            {DeclarationtData?.data?.map(
                              (item: any, index: number) => {
                                // Find corresponding declaration from your state
                                const declaration = declarations.find(
                                  (d: any) =>
                                    d.declaration_id === item.declaration_id
                                ) || { status: "", declaration_text: "" };

                                return (
                                  <div
                                    className="row align-items-center mb-1"
                                    key={item.declaration_id}
                                  >
                                    <div className="col-md-7 ">
                                      <p>
                                        <strong>{index + 1}.</strong>{" "}
                                        {item.content}
                                      </p>
                                    </div>

                                    <div className="col-md-2 p-0">
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`status_${item.declaration_id}`}
                                          value="Yes"
                                          checked={declaration.status === "Yes"}
                                          onChange={() =>
                                            handleDeclarationChange(
                                              item.declaration_id,
                                              "Yes"
                                            )
                                          }
                                          disabled={
                                            data.miscellaneous_id ||
                                              firstRef.ref_id
                                              ? !isEditable
                                              : false
                                          }
                                        />
                                        <label className="form-check-label">
                                          Yes
                                        </label>
                                      </div>

                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`status_${item.declaration_id}`}
                                          value="No"
                                          checked={declaration.status === "No"}
                                          onChange={() =>
                                            handleDeclarationChange(
                                              item.declaration_id,
                                              "No"
                                            )
                                          }
                                          disabled={
                                            data.miscellaneous_id ||
                                              firstRef.ref_id
                                              ? !isEditable
                                              : false
                                          }
                                        />
                                        <label className="form-check-label">
                                          No
                                        </label>
                                      </div>
                                    </div>

                                    <div className="col-md-3 p-0">
                                      {index == 2 ? (
                                        <div
                                          className={`btn w-100 ${declaration.status === "No"
                                            ? "disabled"
                                            : ""
                                            }`}
                                          data-bs-toggle={
                                            declaration.status === "No"
                                              ? ""
                                              : "modal"
                                          }
                                          data-bs-target={
                                            declaration.status === "No"
                                              ? ""
                                              : "#staticBackdrop"
                                          }
                                          style={{
                                            backgroundColor:
                                              declaration.status === "No"
                                                ? "#23527C"
                                                : "#23527C",
                                            color:
                                              declaration.status === "No"
                                                ? "white"
                                                : "White",
                                            pointerEvents:
                                              declaration.status === "No"
                                                ? "none"
                                                : "auto",
                                            cursor:
                                              declaration.status === "No"
                                                ? "not-allowed"
                                                : "pointer",
                                          }}
                                        >
                                          View Reference
                                        </div>
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Add note"
                                          value={declaration.declaration_text}
                                          onChange={(e) =>
                                            handleDeclarationTextChange(
                                              item.declaration_id,
                                              e.target.value
                                            )
                                          }
                                          readOnly={
                                            data.miscellaneous_id ||
                                              firstRef.ref_id
                                              ? !isEditable
                                              : false
                                          }
                                        />
                                      )}
                                    </div>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Buttons */}
                      <div className="d-flex align-items-center justify-content-end">
                        {data.miscellaneous_id ? (
                          isEditable ? (
                            <>
                              <button
                                type="button"
                                className="btn btn-outline-light border w-25"
                                onClick={(e: any) => {
                                  e.preventDefault();
                                  setIsEditable(false);
                                }}
                              >
                                Cancel
                              </button>
                              &nbsp;
                              <button
                                type="submit"
                                className="btn btn-primary w-25"
                                onClick={handleEdit}
                              >
                                Update
                              </button>
                            </>
                          ) : (
                            (() => {
                              const canEdit =
                                status === "In Progress" ||
                                status === "Rejected" ||
                                status === "Re Open" ||
                                status === "Not Started";

                              return (
                                <button
                                  className="btn btn-primary custom_button w-25"
                                  onClick={(e: any) => {
                                    e.preventDefault();
                                    if (canEdit) setIsEditable(true);
                                  }}
                                  disabled={!canEdit}
                                  title={
                                    canEdit
                                      ? "Edit"
                                      : "Editing is disabled for this status"
                                  }
                                  style={{
                                    cursor: canEdit ? "pointer" : "not-allowed",
                                    opacity: canEdit ? 1 : 0.6,
                                  }}
                                >
                                  Edit
                                </button>
                              );
                            })()
                          )
                        ) : (
                          <button
                            type="submit"
                            className="btn btn-primary custom_button w-25"
                            onClick={postData}
                          >
                            Save
                          </button>
                        )}
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
            <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>

      <div
        className="modal fade"
        id="staticBackdrop"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLgLabel">
                Specify Relationship Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeModalBtn"
              />
            </div>

            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <label htmlFor="name1" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name1"
                      placeholder="Enter first name"
                      onChange={getspecref}
                      value={specifyRef.name1}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Relationship</label>
                    <select
                      className="form-select"
                      name="ref1"
                      onChange={getspecref}
                      value={specifyRef.ref1}
                    >
                      <option value="">Select Relationship</option>
                      <option value="spouse">Spouse</option>
                      <option value="child">Child</option>
                      <option value="parent">Parent</option>
                      <option value="sibling">Sibling</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <label htmlFor="name1" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name2"
                      onChange={getspecref}
                      placeholder="Enter first name"
                      value={specifyRef.name2}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Relationship</label>
                    <select
                      className="form-select"
                      name="ref2"
                      onChange={getspecref}
                      value={specifyRef.ref2}
                    >
                      <option value="">Select Relationship</option>
                      <option value="spouse">Spouse</option>
                      <option value="child">Child</option>
                      <option value="parent">Parent</option>
                      <option value="sibling">Sibling</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <label htmlFor="name1" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name3"
                      placeholder="Enter first name"
                      onChange={getspecref}
                      value={specifyRef.name3}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Relationship</label>
                    <select
                      className="form-select"
                      name="ref3"
                      onChange={getspecref}
                      value={specifyRef.ref3}
                    >
                      <option value="">Select Relationship</option>
                      <option value="spouse">Spouse</option>
                      <option value="child">Child</option>
                      <option value="parent">Parent</option>
                      <option value="sibling">Sibling</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-light me-2"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={specpostData}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Miscellaneous;
